import { render } from "./HeroiconsSolidEmojiSad.vue?vue&type=template&id=4d9e49e0"
const script = {}

import exportComponent from "/Users/dennis/PhpstormProjects/lkm/doc_root/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidEmojiSad.vue"]])

export default __exports__